export default __webpack_public_path__ + "static/media/mobBG.766af162.png";